export const isOpenedByParentApp = () => {
  return window.opener && !window.opener.closed;
};

export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(navigator.userAgent) || 
         window.innerWidth <= 768 || 
         ('ontouchstart' in window) ||
         window.navigator.maxTouchPoints > 0;
};

export const isTabletDevice = () => {
  return /iPad|Android(?!.*Mobile)/i.test(navigator.userAgent) || 
         (window.innerWidth > 768 && window.innerWidth <= 1024 && 'ontouchstart' in window);
};

// Detects if the device is running iOS
export const isIOSDevice = () => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

// Detects if the device is running Android
export const isAndroidDevice = () => {
  return /Android/i.test(navigator.userAgent);
};

export const getDeviceType = () => {
  if (isMobileDevice()) return 'mobile';
  if (isTabletDevice()) return 'tablet';
  return 'desktop';
};

export const handleRedirect = (data, redirectPath, baseUrl = window.location.origin) => {
  const openedByParentApp = isOpenedByParentApp();
  const deviceType = getDeviceType();
  
 
  
  const dataObj = data instanceof URLSearchParams ? Object.fromEntries(data.entries()) : data;
  
  if (openedByParentApp) {
    try {
      window.opener.postMessage({ 
        type: 'REDIRECT_DATA',
        data: dataObj,
        redirectPath: redirectPath,
        timestamp: Date.now()
      }, '*');
      
      setTimeout(() => {
        try {
          window.close();
        } catch (e) {
          try {
            window.location.href = 'about:blank';
          } catch (e2) {
            window.location.replace('about:blank');
          }
        }
      }, 500);
    } catch (error) {
      redirectToResult(dataObj, redirectPath, baseUrl);
    }
  } else {
    redirectToResult(dataObj, redirectPath, baseUrl);
  }
};

export const redirectToResult = (data, redirectPath, baseUrl = window.location.origin) => {
  window.location.href = `${baseUrl}${redirectPath}?${new URLSearchParams(data).toString()}`;

};
